import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";

interface DocumentViewerProps {
  signingUrl: string;
  onClose: () => void;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({
  signingUrl,
  onClose,
}) => {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  useEffect(() => {
    // Add event listener for escape key to close viewer
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  return (
    <div className="">
      {/* Header */}

      {loading && (
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
          <CircularProgress />
        </div>
      )}

      {/* Document iframe */}
      <div className="tw-w-full tw-h-[75vh]">
        <iframe
          src={signingUrl}
          className="tw-w-full tw-h-full"
          onLoad={handleIframeLoad}
          title="Document Preview"
        />
      </div>
    </div>
  );
};

export default DocumentViewer;
